import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';

interface IProps {
  remaining: number;
  expanded: boolean;
  onClose: () => void;
  onOpen: () => void;
}

const MoreLessToggle: FC<IProps> = ({ expanded, onClose, onOpen, remaining }) => {
  const { t } = useTranslation();

  return expanded ? (
    <Button fullWidth onClick={onClose}>
      {t('components:showLess')}
    </Button>
  ) : (
    <Button fullWidth onClick={onOpen}>
      {t('components:plusMore', { remaining })}
    </Button>
  );
};

export default MoreLessToggle;
